/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  delete(id, transferTargets = {}) {
    return axios.delete(`${this.url}/${id}`, { params: transferTargets });
  }
}

export default new Agents();
